// ═══════════════════════════════════════════════════════════════════════════
// Módulo Mi negocio — los tableros que miran el negocio entero (2-oct-2026)
// ═══════════════════════════════════════════════════════════════════════════
// No es un canal: compara los canales que la empresa tiene conectados. El
// primero es Precios (la oferta de cada producto en Mercado Libre y en la
// tienda). Vive como solapa propia de la ficha de empresa, grupo
// 'dashboards-mn' de `gestion/lib/tabsEmpresa.js`, que aparece sólo con
// Mercado Libre y la tienda conectados.
//
// El cálculo NO se hace en la pantalla: lo hace el servidor con el mismo
// código de `lib/` (empaquetado por `scripts/build-precios-bundle.mjs`) y lo
// guarda en `dashboardRollups`; la pantalla lee.
//
// Sin bypass de staff: el nodo del tab y la card nacen apagados para todos
// hasta que se tildan en Plataforma → Vista detallada de empresa.

import { DASHBOARDS_MI_NEGOCIO } from './registry'

const GRUPO = 'dashboards-mn'
const GRUPO_LABEL = 'Mi negocio'
const GRUPO_ORDEN = 7

export default {
  id: 'mi-negocio',
  nombre: 'Mi negocio',
  descripcion: 'Tableros que comparan tus canales: hoy, la oferta de cada producto en Mercado Libre y en tu tienda',
  icono: 'scale',
  tipo: 'estrategia',
  version: '0.1.0',
  routes: [],
  menuItems: [],

  // Lo junta el agregador neutro (`core/lib/dashboardsRegistro`).
  dashboards: DASHBOARDS_MI_NEGOCIO,

  // El NODO DEL TAB 'dash-mi-negocio' + una card por dashboard, bajo el grupo
  // propio (mismo molde que Tienda Nube).
  vistasEmpresa: [
    { id: 'dash-mi-negocio', label: 'Mi negocio (tab)', grupo: GRUPO, grupoLabel: GRUPO_LABEL, grupoOrden: GRUPO_ORDEN, orden: -1 },
    ...DASHBOARDS_MI_NEGOCIO.map(d => ({
      id: d.id,
      label: d.nombre,
      grupo: GRUPO,
      grupoLabel: GRUPO_LABEL,
      grupoOrden: GRUPO_ORDEN,
      orden: d.orden ?? 99,
    })),
  ],

  features: [],
  permisoModulos: [],
}
